<template>
  <div>
    <span>
    <span class="issue-status class-column-wrapper">
      <issue-status class="issue-status" :issue="item"/>
    </span>
    <div v-if="userRoleGroup === userGroups.SP"
         class="actions column">
      <edit-delete-issue-button :issue="item"
                                :project-id="item.projectId"
                                @deleteIssueClicked="deleteIssueClickedHandler"
                                @editIssueClicked="editIssueClickedHandler"/>
    </div>
    <div v-if="userRoleGroup === userGroups.CISO && !item.automated"
         class="mark-as-fixed column">
      <change-issue-status-button :issue="item"
                                  :project-id="item.projectId"
                                  @issueStatusChanged="issueStatusChangedHandler"/>
    </div>
  </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { userRoleGroups } from '@/constants/auth';
import IssueStatus from '@/components/issue/IssueStatus.vue';
import ChangeIssueStatusButton from '@/components/issue/ChangeIssueStatusButton.vue';
import EditDeleteIssueButton from '@/components/issue/EditDeleteIssueButton.vue';

export default {
  name: 'IssueStatusTableCell',
  components: {
    IssueStatus,
    ChangeIssueStatusButton,
    EditDeleteIssueButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['userRoleGroup']),
    userGroups() {
      return userRoleGroups;
    },
  },
  methods: {
    issueStatusChangedHandler(data) {
      this.item.status = data.status;
    },
    deleteIssueClickedHandler() {
      this.$emit('deleteIssueClicked', this.item.id);
    },
    editIssueClickedHandler() {
      this.$emit('editIssueClicked', this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.issue-status {
  position: absolute;
  top: 16px;
  &.column {
    padding-right: 0px;
  }
}

.actions {
  display: inline-block;
}

.mark-as-fixed {
  width: 50px;
  display: inline-block;
}

</style>
